<template lang="pug">
  #CerrarOVRechazado
    b-button(
      variant="action"
      @click="openModal"
    )
      | Cerrar OV Rechazado
    //- Modal para confirmar rechazo
    b-modal.hide-footer(v-model="showModal" no-close-on-backdrop, title="Cerrar OV Rechazado")
      h5.center ¿Estás seguro de cerrar la OV rechazada?
      template(#modal-footer='{ ok, cancel, hide }')
        b-button(size='sm' variant='secondary' @click='hideModal' :disabled="loading") No
          b-spinner(v-if="loading" small)
        b-button(size='sm' variant='primary' @click='cerrarRechazado' :disabled="loading") Si
          b-spinner(v-if="loading" small)
  </template>
  <script>
  import { mapActions } from 'vuex'

  export default {
    name: 'RechazarCotizacion',
    data() {
      return {
        showModal: false,
        loading: false,
      }
    },
    props: {
      dataOv: {
        type: Object,
        required: true,
      },
     
    },
    methods: {
      ...mapActions('OVStore', ['closeDeclinedOv']),
      async cerrarRechazado() {
        this.loading = true
        await this.closeDeclinedOv({ id_oportunidad_venta: this.dataOv?.id })
       
        this.loading = false
        this.$emit('reloadAll')
        this.hideModal()
      },
      openModal() {
        this.showModal = true
      },
      hideModal() {
        this.showModal = false
      },
    },
  }
  </script>
  <style lang="scss" scoped>
  .center {
    text-align: center;
    width: 100%;
  }
  </style>
